import React from 'react';
import { AppLogo } from '@/components/shared/display/Logo';

export function NoMatchPage() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex flex-col items-center space-y-24">
        <div>
          <AppLogo size="250px" />
        </div>

        <div className="flex flex-col items-center gap-4">
          <div>
            <h1 className="text-6xl font-bold dm-text-primary">404</h1>
          </div>
          <div>
            <h2 className="text-2xl font-bold dm-text-primary">Page Not Found</h2>
          </div>
          <div className="text-2xl dm-text-secondary">It looks like the page you&apos;re looking for doesn&apos;t exist.</div>
        </div>
      </div>
    </div>
  );
}
